export default "__VITE_ASSET__DfJihm$I__"